
import { Component, Prop, Vue } from "vue-property-decorator";

@Component<any>({})
export default class Success extends Vue {}
